module.exports = __webpack_public_path__ + "assets/img/gd6.65e6d18d.jpg";